import {useNavigate, useParams} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import CustomerCalendarPane from "./pane/CustomerCalendarPane";
import MDBox from "../../components/MDBox";
import CustomerHeader from "../common/CustomerHeader";
import Footer from "../Footer";
import CustomerPageLayout from "../Layout/CustomerPageLayout";
import {CompanyContext} from "../../lib/CompanyProvider";
import {MenuContext} from "../../lib/MenuProvider";
import Meta from "../common/Meta";

export default function CustomerCalendar(props) {
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const [menuContext, setMenuContext] = useContext(MenuContext);

  const navigate = useNavigate();
  const [pageReady, setPageReady] = useState(false);

  useEffect(() => {
    if (companyContext?.company?.guid) {
      setPageReady(true);
    }
  }, [companyContext?.company]);

  const updateMenuContext = () => {
    setMenuContext({...menuContext, refreshContext: true});
  }
  return (
    <>

      <CustomerPageLayout>
        <Meta pageTitle={props?.parties ? 'Parties' : 'Calendar'}/>
        <CustomerHeader props={props}/>
        {pageReady && <MDBox p={2} style={{
          clear: 'both',
          display: 'block',
          width: '100%'
        }}>
          <CustomerCalendarPane calendarView={props?.calendarView || false} parties={props?.parties} />
        </MDBox>
        }
        <Footer/>
      </CustomerPageLayout>
    </>
  )
}